import { createFileRoute, redirect } from '@tanstack/react-router';
import { isSuperAdminFromStorage } from '@/contexts/AuthContext';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const isSuperAdmin = isSuperAdminFromStorage();

    throw redirect({
      to: isSuperAdmin ? '/tenants' : '/dashboard',
    });
  },
});
